// extracted by mini-css-extract-plugin
module.exports = {"input":"tkph8k8zSbUvO3ljAkHyH"};